module.exports = __webpack_public_path__ + "static/media/md-duran-1551170-unsplash.478b7382.jpg";